import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import MobileMenu from '../MobileMenu/MobileMenu'
import colorLogo from '../../images/color-logo.png'
import whiteLogo from '../../images/white-logo.png'
import './Header.css'
import './navbar-glass.css'
import './logo-improvements.css'
import './mega-menu.css'



const Header = (props) => {
    const [scrolled, setScrolled] = useState(true); // Her zaman scrolled gibi görünsün
    const isMobile = window.innerWidth < 992;

    // Scroll effect'i kaldırıyoruz çünkü her zaman scrolled görünmesini istiyoruz
    // useEffect(() => {
    //     const handleScroll = () => {
    //         const isScrolled = window.scrollY > 50;
    //         setScrolled(isScrolled);
    //     };

    //     window.addEventListener('scroll', handleScroll);
    //     handleScroll(); // Check initial scroll position

    //     return () => {
    //         window.removeEventListener('scroll', handleScroll);
    //     };
    // }, []);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }



    return (
        <header id="header">
            <div className={`${props.hclass} ${scrolled ? 'scrolled' : ''}`}>
                <nav className="navigation navbar navbar-expand-lg navbar-light">
                    <div className="container-fluid">
                        <div className="row align-items-center">
                            <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                                <MobileMenu />
                            </div>
                            <div className="col-lg-2 col-md-6 col-6">
                                <div className="navbar-header">
                                    <Link onClick={ClickHandler} className="navbar-brand" to="/home">
                                        <img 
                                            src={isMobile ? colorLogo : (scrolled ? colorLogo : whiteLogo)} 
                                            alt="Amped Therapeutics" 
                                            style={{height: '40px', width: 'auto'}} 
                                        />
                                    </Link>
                                </div>
                            </div>
                            <div className="col-lg-7 col-md-1 col-1">
                                <div id="navbar" className="collapse navbar-collapse navigation-holder">
                                    <button className="menu-close"><i className="ti-close"></i></button>
                                    <ul className="nav navbar-nav mb-2 mb-lg-0">
                                        <li><Link onClick={ClickHandler} to="/">Home</Link></li>
                                        <li><Link onClick={ClickHandler} to="/about">About</Link></li>
                                        <li className="menu-item-has-children mega-menu-parent">
                                            <Link onClick={ClickHandler} to="/treatments">Treatments</Link>
                                            <div className="mega-menu">
                                                <div className="mega-menu-container">
                                                    <div className="mega-menu-column">
                                                        <h4 className="mega-menu-title" style={{cursor: 'default', pointerEvents: 'none'}}>
                                                            Pain & Orthopedics
                                                        </h4>
                                                        <ul>
                                                            <li><span>Joint Pain & Arthritis Solutions</span></li>
                                                            <li><span>Chronic Pain Management</span></li>
                                                            <li><span>Headache Treatment</span></li>
                                                            <li><span>Athletic Performance &<br/>Sports Medicine</span></li>
                                                        </ul>
                                                    </div>
                                                    <div className="mega-menu-column">
                                                        <h4 className="mega-menu-title" style={{cursor: 'default', pointerEvents: 'none'}}>
                                                            Neurological & Cognitive
                                                        </h4>
                                                        <ul>
                                                            <li><span>Neurological Recovery &<br/>Support</span></li>
                                                            <li><span>Neurodegenerative &<br/>Dementia Therapy</span></li>
                                                            <li><span>Developmental Disorders<br/>Autism Spectrum</span></li>
                                                        </ul>
                                                    </div>
                                                    <div className="mega-menu-column">
                                                        <h4 className="mega-menu-title" style={{cursor: 'default', pointerEvents: 'none'}}>
                                                            Wellness & Performance
                                                        </h4>
                                                        <ul>
                                                            <li><span>Sexual Wellness &<br/>Performance</span></li>
                                                            <li><span>Anti-Aging & Longevity</span></li>
                                                            <li><span>Men's Health</span></li>
                                                            <li><span>MUSE Cell Therapy</span></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li><Link onClick={ClickHandler} to="/international">International Patients</Link></li>
                                        <li><Link onClick={ClickHandler} to="/faq">FAQ</Link></li>
                                        <li><Link onClick={ClickHandler} to="/blog">Blog</Link></li>
                                        <li><Link onClick={ClickHandler} to="/contact">Contact</Link></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-2 col-2">
                                <div className="header-right">
                                    <div className="header-cta">
                                        <Link to="/contact" className="theme-btn">
                                            <i className="flaticon-telephone"></i> Schedule Your Consultation
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    )
}
export default Header;